import React from 'react';
import { useI18n } from '../../context/I18nContext';
import { authColors } from '../../styles/colors';
import Spinner from '../ui/Spinner';

interface CheckoutLoadingScreenProps {
  /** Message key to display (optional) */
  messageKey?: 'auth.redirectingToPayment' | 'auth.redirectingToApp' | 'auth.redirectingToResetPassword' | 'billing.processingTitle';
  /** If false, only show the spinner (no text) */
  showMessage?: boolean;
}

/**
 * Fullscreen loading screen for checkout/payment redirects.
 * 
 * Standard SaaS: Consistent loading experience across auth pages
 * during Stripe checkout flow.
 */
const CheckoutLoadingScreen: React.FC<CheckoutLoadingScreenProps> = ({ 
  messageKey = 'auth.redirectingToPayment',
  showMessage = true,
}) => {
  const { t } = useI18n();

  return (
    <div 
      className={`h-screen w-full flex items-center justify-center ${authColors.backgroundGradient} overflow-hidden`}
      style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999 }}
    >
      <div className="text-center">
        <div className="flex justify-center">
          <Spinner size="lg" />
        </div>
        {showMessage ? (
          <p className="mt-4 text-gray-600">{t(messageKey)}</p>
        ) : null}
      </div>
    </div>
  );
};

export default CheckoutLoadingScreen;
